<template>
  <TenderPlug
    :title="$t('No contractors yet')"
    :description="
      $t(
        'Invite bidders using the button below. They will receive an automatic invitation and Fixtender support will help them send you offers.'
      )
    "
    icon="bell"
    large
  >
    <template #action>
      <Button icon="plus">
        {{ $t('Add contractor') }}
      </Button>
    </template>
  </TenderPlug>
</template>

<script>
  import TenderPlug from '@/components/tender/TenderPlug';
  import Button from '@/components/ui-v2/Button';
  export default {
    name: 'ContractorsPlug',
    components: { Button, TenderPlug },
  };
</script>
